import React from 'react'
import Layout from '../../../Layout'
import AddDriverContainer from '../../../../../Components/UserPart/AddUser/AddDriverContainer/AddDriverContainer'

const AddDriver = () => {
  return (
    <Layout>
        <AddDriverContainer/>
    </Layout>
  )
}

export default AddDriver